import React, { useState, useEffect, useContext } from "react";
import StockistReportHeader from "../stockist_report/StockistReportHeader";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import OtherSidebar from "../operator_home/sidebar/Sidebar";
import { ReactSession } from "react-client-session";
import './Claim.css'
import Filter from "./Filter";
import ClaimTable from "./claim_table/ClaimTable";
import { ClaimAPI } from "./ClaimAPI";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { errorToast } from "../../toast";
import { Pagination } from "./claim_table/Pagination";
import FormContext from '../../context/FormContext';


const Claim = () => {
    const role = ReactSession.get("role");
    const [claimRecord, setClaimRecord] = useState([])
    const [pagination, setPagination] = useState({
        next: null,
        previous: null,
        count: null
    })
    const {setIsLoading} = useContext(FormContext)
    const axiosPrivate = useAxiosPrivate()


    const fetchClaimArray = async () => {
        try {
            setIsLoading(true)
            const response = await ClaimAPI(axiosPrivate);
            if (response.status === 200) {
                setClaimRecord(response.data.results);
                setPagination((prev) => ({
                    ...prev, 
                    next: response.data?.next,
                    previous: response.data?.previous,
                    count: response.data?.count
                }))
            }
        } catch (error) {
            errorToast(`Failed to fetch Claim list: error:${error.response.status}`, 2000);
        }
        finally{
            setIsLoading(false)
        }
    };
    useEffect(() => {
        fetchClaimArray();
    }, []);

    return (
        <div className="claim__page">
            <StockistReportHeader />
            {role === '2' ? <Sidebar /> : <OtherSidebar />}
            <div className="claim__container">
                <p className="claim__lab">Stockist Information</p>
                <Filter setClaimRecord={setClaimRecord} setPagination={setPagination}  fetchClaimArray={fetchClaimArray}/>
                <Pagination pagination={pagination} setPagination={setPagination} setClaimRecord={setClaimRecord} />
                <ClaimTable 
                    claimRecord={claimRecord}
                    setClaimRecord={setClaimRecord}
                />
            </div>
        </div>
    );
};

export default Claim;